"use client";

import { SidebarFooter } from "@/components/doc/left-sidebar/SidebarFooter";
import { twMerge } from "@/utils/twMerge";

export const MobileFooter = () => {
  return (
    <div className={twMerge("hidden sm:flex", "flex-col mt-auto mx-6 mb-5")}>
      <div className="h-[1px] mt-20 mb-5 border-b border-gray-200 dark:border-gray-800" />
      <SidebarFooter />
    </div>
  );
};
